module.exports = require("./declare.js");